import Axios, { AxiosError } from "axios";
 
//import Axios, {
// AxiosRequestConfig,
//  AxiosResponse,
//  AxiosError,
//  InternalAxiosRequestConfig,
//} from "axios";

//const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://gangwha-api.dvconsulting.org/api/v1';
 const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api.prds.kr/ganghwa/api/v1';

class CoreAPIService {
  axiosInstance;

  constructor(baseURL = BASE_URL) {
    this.axiosInstance = Axios.create({
      baseURL,
      headers: {
        "Content-Type": "application/json",
      },
    });

    // 🔹 Request Interceptor: Attach Token Automatically
    this.axiosInstance.interceptors.request.use(
      async (config) => {
        const token = localStorage.getItem("authToken");
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      },
      (error) => Promise.reject(error)
    );

    // 🔹 Response Interceptor: Handle Errors
    this.axiosInstance.interceptors.response.use(
      (response) => response,
      async (error) => this.handleError(error)
    );
  }

  // ✅ Standardized Error Handling
  handleError = async (error) => {
    // console.error("❌ API Error:", error);
    let errorMessage = "An unexpected error occurred.";

    if (error.response) {
      const errorData = error.response.data;
      errorMessage =
        errorData.error || errorData.message || `Server Error (${error.response.status})`;


      if (error.response.status === 401) {
        localStorage.removeItem('authToken');
        localStorage.removeItem('userInfo');
        localStorage.removeItem('isLoggedIn');

        alert("세션이 만료되었습니다");
        window.location.href = "/login";
        return;
      } else if (error.response.status === 403) {
        localStorage.removeItem('authToken');
        localStorage.removeItem('userInfo');
        localStorage.removeItem('isLoggedIn');

        alert("권한 없음");
        window.location.href = "/login";
      } else if (error.response.status === 500) {
        alert("서버 오류가 발생했습니다.", error.response.status);
      }
    } else if (error.request) {
      errorMessage = "No response from server. Please try again later.";
      window.location.href = "/service-use-notice";
    } else {
      errorMessage = error.message;
      window.location.href = "/service-use-notice";
    }

    return Promise.reject(error);
  };


  // ✅ Generic API Methods
  async post(url, data = {}, config = {}) {
    return this.axiosInstance.post(url, data, config).then((res) => res.data);
  }

  async get(url, params = {}, config = {}) {
    return this.axiosInstance.get(url, { params, ...config }).then((res) => res.data);
  }

  async put(url, data = {}, config = {}) {
    return this.axiosInstance.put(url, data, config).then((res) => res.data);
  }

  async delete(url, data = {}, config = {}) {
    return this.axiosInstance.delete(url, { data, ...config }).then((res) => res.data);
  }

  async patch(url, data = {}, config = {}) {
    return this.axiosInstance.patch(url, data, config).then((res) => res.data);
  }
}

export default CoreAPIService;
